import { Controller } from "@hotwired/stimulus"

// Toggles the export-instructions tabs ("On iPhone" / "Already exported"),
// matching the prototype's setDev(). Each tab and panel carries data-tab; the
// active tab gets .on and the matching panel loses .hidden. Progressive
// enhancement: with JS off, the default (iOS) panel is visible and the desk
// panel stays hidden — the written steps are still fully reachable.
export default class extends Controller {
  static targets = ["tab", "panel"]

  select(event) {
    const name = event.currentTarget.dataset.tab
    this.tabTargets.forEach((t) => t.classList.toggle("on", t.dataset.tab === name))
    this.panelTargets.forEach((p) => p.classList.toggle("hidden", p.dataset.tab !== name))
  }
}
